// Constants shared by the PDF generator and the editor. Kept dependency-free so
// the editor can import them without pulling opentype.js into the bundle.

// Breathing room (mm) between a hug (auto-width) text box's wrap ceiling and the
// page edge. Both the generator (`buildTextOp`) and the editor (`ElementBox`)
// subtract this — if they drift, each re-wraps at a width the other committed to.
export const RIGHT_MARGIN_MM = 5;

// PostScript points per millimetre: the layout model works in mm, PDF works in points.
export const PT_PER_MM = 72 / 25.4;

export const mmToPt = (mm: number): number => mm * PT_PER_MM;
export const ptToMm = (pt: number): number => pt / PT_PER_MM;
